import { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import * as styles from "./BlockQuote.css";
import { BlockQuote as IBlockQuote } from "~/sanity/types";
import PortableText, { IPortableText } from "../portableText/PortableText";
// @ts-ignore
import { Paragraph } from "./Paragraph";

export type BlockQuoteProps = ComponentPropsWithoutRef<"div"> &
  PropsWithChildren & { data: IBlockQuote };

export const BlockQuote = ({ data, ...props }: BlockQuoteProps) => {
  const { quote, author } = data;
  return (
    <blockquote className={styles.blockQuote}>
      <PortableText blocks={quote as IPortableText} className={styles.quote} />
      {author && (
        <Paragraph size="smMd" className={styles.author}>
          — {author}
        </Paragraph>
      )}
    </blockquote>
  );
};
